
$(function() {

    function cart_sidebar_html(data) {
        return `
            <div class='product-footer'>
                ${card_product_list(data.items)} 
            </div>
            <div class="cx-sidebar-footer cart-footer">
                <div class="wbg-subtotal-row">
                 <p class="subtotal-heading">Total Price</p>
                 <strong class='cart-item-subtotal'> ${ (data.original_total_price/100).toFixed(2)}</strong>                                
                </div>
                <div class="buttons-list">
                    <a class='cx_btn cx_btn_tertiary cart_custom wbg-darwer-cart-btn' href='/cart'> Go to Cart </a>
					<a  class='cx_btn cx_btn_tertiary checkout_custom' href='/checkout'> Checkout Now </a>
                </div>
            </div> 

        `
    }
    function card_product_list(list) {
        var str = "";

        $.each(list, function (kk, item) {

            str += `
            <div class="products-list">
                <div class="cart-item-single type-${item.product_type}">

                    <div class='cart-item-thumbnail txt-center'>
                        <img src='${item.image}' class='w s8 mauto'>
                    </div>

                    <div class='cart-item-details'>
                        <p class='cart-item-product-title'>
                            <a href='${item.url}'>${item.product_title}</a>
                        </p>
                        <div class='price-qty'>
                            <div class='cart-item-qty-container'>
                                <input class='
                                    update-cart-item 
                                    number_feild_init 
                                    cx-update-cart-item-qty' 
                                    data-cart_item_key='${item.key}' type='number' min='1' value='${item.quantity}'
                                    data-variant_id='${item.variant_id}' />
                            </div>
                        <span class='cx_btn cx-api cx-remove-cart-item cx-api-btn' data-variant_id='${item.variant_id}'  data-cart_item_key='${item.key}'>
                            Remove Item
                        </span>                            
                        </div>
                    </div>
                        <div class="individual-product-total">
                            <span class='cart-item-price'> ${ (item.final_line_price/100).toFixed(2) }</span>
                        </div>
                </div>
            </div>
            `;
        })
        return str;
    }

  $(document).on("click", "#cart-icon-bubble", function(e){
    const SmartCart = window.Rebuy.SmartCart;
    SmartCart.show();
  });
  /*
    $(document).on("click","a.cx_btn.checkout_custom ", function (e) {

      var total_for_all_products = 0;
      fetch("https://www.atwaterskin.com/cart.js")
      .then((Response)=> {
          return Response.json();
      })
      .then((data) => {
          console.log(data);
      })
    });

    $('.product-form__submit, .header__icon--cart').click(function () {
        var clk_ths = $(this);

        cx_sidebar.open(function ($content) {
            
            window.current_sidebar_content = $content;

          setTimeout(function() {
            
            $.ajax({
                url : "/cart.js",
                type : "GET"
            }).done(function(data) {
                console.log(data);
                data = JSON.parse(data);
				//console.log(data);
                var sidebar_inner_content = cx_sidebar.setup_content({

                    title: 'CURRENT CART',
                    sidebar_class: "user_cart_sidebar cart-sidebar",
                    sub_title: data.item_count + ` items  `
                }, $content);

                sidebar_inner_content.html(cart_sidebar_html(data));

                sidebar_inner_content.find('.number_feild_init').number_feild();


                cx_sidebar.show_content(300);
            });
            
          },300);
            
            


        });
    });

    $("body").on("change" , ".update-cart-item", function() {

        var key = $(this).attr("data-cart_item_key");
        var pp =  $(this).parents(".cart-item-single");

        pp.addClass("loading");

        var quantity = $(this).val();;

        
        $.ajax({
            url : window.Shopify.routes.root + 'cart/change.js',
            method : "POST",
            data  :{
                id : key,
                quantity : quantity
            }
        }).done(function(data) {
            
            data = JSON.parse(data);
            pp.removeClass("loading");
            if ( window.location.pathname.indexOf("/cart") == 0 ) {

                window.location.reload();

            } 
            var sidebar_inner_content = cx_sidebar.setup_content({

                title: 'CURRENT CART',
                sidebar_class: "user_cart_sidebar cart-sidebar",
                sub_title: data.item_count + ` items  `,
            }, window.current_sidebar_content);

            sidebar_inner_content.html(cart_sidebar_html(data));

            sidebar_inner_content.find('.number_feild_init').number_feild();


            cx_sidebar.show_content(10);


        });
    });
    
    $("body").on("click" , ".cx-remove-cart-item", function() {

        var key = $(this).attr("data-cart_item_key");
        var pp =  $(this).parents(".cart-item-single");

      
        pp.addClass("loading");

        $.ajax({
            url : window.Shopify.routes.root + 'cart/change.js',
            method : "POST",
            data  :{
                id : key,
                quantity : 0
            }
        }).done(function(data) {
            data = JSON.parse(data);
            pp.remove();
            if ( window.location.pathname.indexOf("/cart") == 0 ) {
                window.location.reload()
            }

            var sidebar_inner_content = cx_sidebar.setup_content({

                title: 'CURRENT CART',
                sidebar_class: "user_cart_sidebar cart-sidebar",
                sub_title: data.item_count + ` items  `,
            }, window.current_sidebar_content);

            sidebar_inner_content.html(cart_sidebar_html(data));

            sidebar_inner_content.find('.number_feild_init').number_feild();


            cx_sidebar.show_content(10);

        });
    });
  */
})